export default __webpack_public_path__ + "static/media/logo.9304876c.svg";